<template>
  <ValidationProvider
    v-slot="{ errors, valid }"
    :name="$attrs.label || $attrs.name"
    :rules="rules">
    <v-text-field
      v-model="innerValue"
      :error-messages="errors"
      :success="valid"
      v-bind="$attrs"
      v-on="$listeners" />
  </ValidationProvider>
</template>

<script>
  export default {
    name: 'ValidationInput',
    props: {
      value: {
        type: null,
        required: true
      },
      rules: {
        type: [Object, String],
        default: ''
      }
    },
    data () {
      return {
        innerValue: null
      }
    },
    watch: {
      // Handles internal model changes.
      innerValue (newVal) {
        this.$emit('input', newVal)
      },
      // Handles external model changes.
      value (newVal) {
        this.innerValue = newVal
      }
    },
    created () {
      if (this.value) {
        this.innerValue = this.value
      }
    }
  }
</script>

<style scoped>
</style>
